import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "BaseItemDialog__image relative-position" }
const _hoisted_2 = { class: "column no-wrap gap-12 relative-position" }
const _hoisted_3 = { class: "row items-center gap-sm" }
const _hoisted_4 = { class: "fs-17px fw-600 text-cool-gray-100" }
const _hoisted_5 = { class: "BaseItemDialog__name fs-17px fw-600 text-cool-gray-100 flex-1" }
const _hoisted_6 = { class: "flex no-wrap items-center gap-xs" }
const _hoisted_7 = {
  key: 0,
  class: "fs-10px fw-500 text-cool-gray-80 q-mt-xs"
}
const _hoisted_8 = { class: "fs-17px fw-600 text-cool-gray-100" }
const _hoisted_9 = {
  key: 0,
  class: "fs-15px text-cool-gray-80 block"
}
const _hoisted_10 = {
  key: 2,
  class: "row items-center gap-sm"
}

import { reactive, ref } from 'vue'
import { formatMonetaryAmount } from 'src/common/helpers/generator/monetaryAmount.helper'
import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'
import { IItemView } from 'src/common/interfaces'

interface IProps {
  item: IItemView
  currency: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseItemDialogPreview' },
  __name: 'BaseItemDialogPreview',
  props: {
    item: {},
    currency: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v1911529e": (cssValues.overlayHeight),
  "v9eefd6be": (cssValues.wrapperHeight),
  "v2163779e": (cssValues.arrowSize),
  "v3895357c": (navigationOffsetRef.value),
  "v490c4ff8": (navigationWrapperRef.value),
  "v34f9d3f8": (cssValues.dotWrapperSize),
  "v6a31a99e": (cssValues.dotSize),
  "v96c4a208": (cssValues.activeDotWidth)
}))


const props = __props

const { t: globalT } = translate(globalTranslateObject)

const state = reactive({ slide: 0 })
const navigationOffsetRef = ref('0')
const navigationWrapperRef = ref('0')

const cssValues = {
  overlayHeight: '30px', // Item image bottom overlay height
  dotSize: '4px', // Navigation dot size
  dotWrapperSize: '14px', // Navigation dot wrapper size
  activeDotWidth: '20px', // Active navigation dot size
  arrowSize: '16px', // Navigation arrow size
  wrapperHeight: '20px', // Navigation wrapper height
}

if (props.item?.images?.length) {
  const navigationDotsWidth = `calc(${props.item?.images?.length} * ${cssValues.dotWrapperSize} + (${cssValues.activeDotWidth} - ${cssValues.dotSize})`
  navigationOffsetRef.value = `calc((${navigationDotsWidth}) / 2 + ${cssValues.arrowSize})`
  navigationWrapperRef.value = `calc(${navigationDotsWidth} + 2 * ${cssValues.arrowSize})`
}

return (_ctx: any,_cache: any) => {
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_status = _resolveComponent("k-status")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseItemDialog__preview", { 'bg-white': __props.item.images.length }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.item.images.length)
        ? (_openBlock(), _createBlock(_component_q_carousel, {
            key: 0,
            modelValue: state.slide,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.slide) = $event)),
            animated: "",
            arrows: __props.item.images.length > 1,
            navigation: __props.item.images.length > 1,
            infinite: "",
            height: "288px"
          }, {
            "navigation-icon": _withCtx(({ name, btnProps, onClick }) => [
              _createVNode(_component_q_btn, _mergeProps(btnProps, {
                class: ["q-carousel__navigation-icon", `q-carousel__navigation-icon--${name === state.slide ? '' : 'in'}active`],
                onClick: onClick
              }), null, 16 /* FULL_PROPS */, ["class", "onClick"])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.images, (image, index) => {
                return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                  key: index,
                  name: index,
                  "img-src": image
                }, null, 8 /* PROPS */, ["name", "img-src"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "arrows", "navigation"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["q-px-20 relative-position overflow-hidden", [
        __props.item.images.length ? 'BaseItemDialog__details q-pt-20' : 'BaseItemDialog__details--imageless bg-white q-pt-md',
      ]])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, " #" + _toDisplayString(__props.item.id), 1 /* TEXT */),
          _createVNode(_component_q_separator, {
            color: "cool-gray-30",
            size: "2px",
            vertical: ""
          }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.item.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_6, [
            (__props.item.price_type === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(globalT)('from')), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatMonetaryAmount)(__props.item.default_price, __props.currency)), 1 /* TEXT */),
            _createCommentVNode(" <span class=\"fs-15px fw-500 text-cool-gray-80\"> ({{ globalT('per') }} {{ item.sell_unit_str }}) </span> ")
          ])
        ]),
        (__props.item.description)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.item.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (__props.item.item_tags.length)
          ? (_openBlock(), _createBlock(_component_k_divider, {
              key: 1,
              size: "md"
            }))
          : _createCommentVNode("v-if", true),
        (__props.item.item_tags.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.item_tags_data, (tag, index) => {
                return (_openBlock(), _createBlock(_component_k_status, {
                  key: index,
                  label: tag.name,
                  status: tag.colour,
                  color: "white",
                  "border-color": "off-white-20"
                }, null, 8 /* PROPS */, ["label", "status"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})